import { render, staticRenderFns } from "./ScoreEvolutionChart.vue?vue&type=template&id=6c071ec1&scoped=true&"
import script from "./ScoreEvolutionChart.vue?vue&type=script&lang=js&"
export * from "./ScoreEvolutionChart.vue?vue&type=script&lang=js&"
import style0 from "./ScoreEvolutionChart.vue?vue&type=style&index=0&id=6c071ec1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c071ec1",
  null
  
)

export default component.exports